import React, { FC, useState } from 'react';
import { GroupBase, OptionsOrGroups, components } from 'react-select';
import Select from 'react-select/async';
import './_styles.autocomplete.css';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';
import { FaSearch } from 'react-icons/fa';

interface AutoCompleteProps {
  title: string;
  loadOptions:
    | ((
        inputValue: string,
        callback: (
          options: OptionsOrGroups<unknown, GroupBase<unknown>>
        ) => void
      ) => void | Promise<OptionsOrGroups<unknown, GroupBase<unknown>>>)
    | undefined;
  onChange: (value: SelectOption) => void;
  delay?: number;
  defaultValue?: string;
  readOnly?: boolean;
}

type SelectOption = { label: string; value: string };

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <FaSearch />
    </components.DropdownIndicator>
  );
};

const AutoComplete: FC<AutoCompleteProps> = ({
  title,
  loadOptions,
  onChange,
  delay = 0,
  defaultValue,
  readOnly = false
}) => {
  const [value, setValue] = useState('');
  return (
    <motion.div
      className='auto-complete'
      variants={fadeIn(0.5 + delay)}
      initial='hidden'
      animate='enter'
      exit='exit'
    >
      <p>{title}</p>
      <div className='auto-complete-container'>
        <Select
          onChange={(value) => {
            onChange(value as SelectOption);
          }}
          isDisabled={readOnly}
          onInputChange={(e: string) => {
            setValue(e);
          }}
          defaultValue={{ label: defaultValue, value: defaultValue }}
          noOptionsMessage={() => (value ? 'No Results' : null)}
          loadOptions={loadOptions}
          menuPortalTarget={document.body}
          isSearchable
          className='w-full z-50'
          components={{ DropdownIndicator }}
          styles={{
            noOptionsMessage: (p: any) => ({
              ...p,
              color: 'white'
            }),
            placeholder: (p: any) => ({
              ...p,
              color: 'white',
              opacity: 0.5
            }),
            input: (i: any) => ({
              ...i,
              color: 'white'
            }),
            control: (c: any) => ({
              ...c,
              backgroundColor: 'transparent',
              border: `2px solid var(--primary)`,
              padding: 2,
              color: 'white',
              backdropFilter: 'blur(4px)',
              zIndex: `100 !important`
            }),
            menu: (m: any) => ({
              ...m,
              backgroundColor: 'transparent',
              backdropFilter: 'blur(4px)',
              borderRadius: '0.25rem',
              overflow: 'hidden',
              fontWeight: '700',
              color: '#1d1e20',
              border: '2px solid var(--primary)',
              dropShadow: 'none'
            }),
            singleValue: (s: any) => ({
              ...s,
              color: 'white'
            }),
            option: (provided, state) => ({
              ...provided,
              backdropFilter: 'blur(8)',
              backgroundColor: 'transparent',
              color: 'white',
              zIndex: `100 !important`
            }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 })
          }}
        />
      </div>
    </motion.div>
  );
};

export default AutoComplete;
